module.exports = __webpack_public_path__ + "img/theta.10898be1.svg";